import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./AddTargetSpecification.scss";
import { Stepper } from "../../../Stepper/Stepper";
import { useSelector, useDispatch } from "react-redux";
import { TargetIntensityValidationModal } from "./TargetIntensityValidationModal";
import { Tooltip } from "../../../CommonUIComponents/Tooltip/Tooltip";
import {
  CancelBtn,
  SaveBtn,
  addTargetSpecificationBaseYear,
  addTargetSpecificationBaseYearGreaterThanFEY,
  addTargetSpecificationBaseYearLessThanMRY,
  addTargetSpecificationBaseYearRequired,
  addTargetSpecificationEmissionRequired,
  addTargetSpecificationForecastNameRequired,
  addTargetSpecificationGeoRequired,
  addTargetSpecificationName,
  addTargetSpecificationOrgRequired,
  addForecastSpecificationDataSelectionRequired,
  addTargetSpecificationPercentValueAnnual,
  addTargetSpecificationPercentValueTargetYear,
  addTargetSpecificationTargetDesc,
  addTargetSpecificationTargetName,
  addTargetSpecificationTargetTemporalType,
  addTargetSpecificationTargetType,
  addTargetSpecificationTargetTypeOptions,
  addTargetSpecificationTargetTypeRequired,
  addTargetSpecificationTargetYear,
  addTargetSpecificationTargetYearGreaterThanMRY,
  addTargetSpecificationTargetYearLessThanFEY,
  addTargetSpecificationTargetYearRequired,
  addTargetSpecificationTemporalTypeOptions,
  addTargetSpecificationTemporalTypeRequired,
  targetPercentageError,
  addTargetSpecificationPercentValueAnnualRequired,
  addTargetSpecificationPercentValueTargetYearRequired,
  targetDescriptiontooltip,
  targetTypetooltip,
  temporalTypeTooltip,
  targetPercentageTooltip,
  targetBaseYearTooltip,
  targetYearTooltip,
  targetNameTooltip,
  decimalNumberRegExpTarget,
  DataSelection,
  maxLength100,
  addTargetNameRequiredMaxLength,
  addTargetDescriptionMaxLength,
  targetNameRegExp,
  targetDescRegExp,
  wafErrorMessage,
  commonError,
  maxLength2000
} from "../../../../util/constants";
import { Input } from "../../../CommonUIComponents/Input/Input";
import { TextArea } from "../../../CommonUIComponents/TextArea/TextArea";
import { Button } from "../../../CommonUIComponents/Button/Button";
import { AddIcon, EmissionIcon, AreaSeacrhIcon } from "../../../../icons";
import { routes } from "../../../../routes/routes.constatns";
import { Select } from "../../../CommonUIComponents/Select/Select";
import { getHierarchyLevelData } from "../../../../store/services/engagement.service";
import {
  getForecastTargetByGroupId,
  saveTargetSpecification,
  updateTargetSpecification,
  allSaveTargetSpecification,
  checkName,
  allUpdateTarget,
} from "../../../../store/services/forecast.service";
import {  MotifErrorMessage } from "../../../../assets/lib/motif";
import { LoadingIndicatorEmbed } from "../../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { setHierarchialData, setselectedUIAllFilters } from "../../../../store/slices/forecastSlice";
import { M2FilterModal } from "../../AddForecast/AddSpecification/M2FilterModal";
import { 
  processEmissionData, 
  handleAllpayload, 
  processCustomData,
  processOrgData, 
  processRegionData 
} from "../../AddForecast/AddSpecification/ForecastUtils";
import { setWafErrorFlag } from "../../../../store/slices/projectSlice";

export function AddTargetSpecification() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const steps = useSelector((state) => state.stepper.steps);
  const engagement = useSelector((state) => state.engagement.engagement);
  const stepIndex = useSelector((state) => state.engagement.stepIndex);
  const currentStep = useSelector((state) => state.engagement.currentStep);
  const user = useSelector((state) => state.user.user);
  const selectedUIAllFilters = useSelector(
      (state) => state.forecast.selectedUIAllFilters
    );
  
  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);  
  const [wafErrorMessageState, setWafErrorMessageState] = useState("");
  const [isDataSaveInProgress, setIsDataSaveInProgress] = useState(false);
  const [targetSpecName, setTargetSpecName] = useState("");
  const [targetDescription, setTargetDescription] = useState("");
  const [targetSpecType, setTargetSpecType] = useState("");
  const [targetSpecTypeDisable, setTargetSpecTypeDisable] = useState(false);
  const [targetSpecTemporalType, setTargetSpecTemporalType] = useState("");
  const [percentageValue, setPercentage] = useState();
  const [baseSpecYear, setBaseSpecYear] = useState();
  const [targetSpecYear, setTargetSpecYear] = useState();

  const [targetErrorName, setTargetErrorName] = useState("");
  const [targetErrorDescription, setTargetErrorDescription] = useState("");
  const [targetErrorType, setTargetErrorType] = useState("");
  const [targetErrorTemporal, setTargetErrorTemporal] = useState("");
  const [targetErrorPercent, setTargetErrorPercent] = useState("");
  const [targetErrorBaseYear, setTargetErrorBaseYear] = useState("");
  const [targetErrorTargetYear, setTargetErrorTargetYear] = useState("");

  const [emissionModalData, setEmissionModalData] = useState([]);
  const [geoSpecModalData, setGeoSpecModalData] = useState([]);
  const [orgSpecModalData, setOrgSpecModalData] = useState([]);
  const [customModalData, setCustomModalData] = useState([]);
  const [forecastErrorDataSelectionModal, setForecastErrorDataSelectionModal] = useState("");
  const [targetData, setTargetData] = useState({});
  const [dropdownError, setDropDownError] = useState(false);
  const [alternativeOutput, showAlternativeOutput] = useState(false);
  const [intenstiyTargetDataSet, setIntensityTargetData] = useState({});
  const [targetDataType, setTargetIntensityDataType] = useState("");
  const [targetOutput, setTargetIntensityOutputUnit] = useState("");
  const [targetyearData, setTargetIntensityYearData] = useState({});
  const [showTargetValidationMsg, setShowTargetValidationMsg] = useState(false);
  const [isEditTarget, setIsEditTarget] = useState(false);
  const decimalNumberRegExp = decimalNumberRegExpTarget;
  const lastCheckedTargetName = useRef("");
  const [isDisableSave, setIsDisableSave] = useState(false);
  const [openHierarchyModal, setOpenHierarchyModal] = useState(false);
  const [hierarchialData, setHierarchyData] = useState([]);

  useEffect(() => {
    if (wafErrorFlag) {
      setWafErrorMessageState(wafErrorMessage);
    }
  }, [wafErrorFlag]);

  useEffect(() => {
    if (
      targetSpecType === "Intensity" &&
      baseSpecYear &&
      targetSpecYear &&
      !isEditTarget &&
      !targetErrorBaseYear &&
      !targetErrorTargetYear
    ) {
      // disableOutputCheckbox(false);
    } else if (
      isEditTarget &&
      targetSpecType === "Intensity" &&
      (targetDataType !== "" ||
        targetOutput !== "" ||
        targetyearData.length > 0)
    ) {
      showAlternativeOutput(true);
      // showActivityOutputTableFun(true);
    } else {
      showAlternativeOutput(false);
      // disableOutputCheckbox(true);
    }
  }, [
    targetSpecType,
    baseSpecYear,
    targetSpecYear,
    isEditTarget,
    targetErrorBaseYear,
    targetErrorTargetYear,
    targetDataType,
    targetOutput,
    targetyearData,
  ]);

  function handleCancelClick() {
    navigate(`/${routes.createNewEngagement}/${routes.addTarget}`, {
      state: {
        engagementId: engagement.id,
      },
      gestureEnabled: false,
    });
  }

  function validateForm() {
    let isValid = true;

    if (!targetSpecName) {
      setTargetErrorName(addTargetSpecificationForecastNameRequired);
      isValid = false;
    }

    if (!targetSpecType) {
      setTargetErrorType(addTargetSpecificationTargetTypeRequired);
      isValid = false;
    }

    if (!targetSpecTemporalType) {
      setTargetErrorTemporal(addTargetSpecificationTemporalTypeRequired);
      isValid = false;
    }

    if (!percentageValue) {
      setTargetErrorPercent(
        targetSpecTemporalType === "Annual"
          ? addTargetSpecificationPercentValueAnnualRequired
          : addTargetSpecificationPercentValueTargetYearRequired
      );
      isValid = false;
    }

    if (
      percentageValue &&
      (!decimalNumberRegExp.test(percentageValue) || percentageValue > 100)
    ) {
      setTargetErrorPercent(targetPercentageError);
      isValid = false;
    }

    if (!baseSpecYear) {
      setTargetErrorBaseYear(addTargetSpecificationBaseYearRequired);
      isValid = false;
    }

    if (baseSpecYear && parseFloat(baseSpecYear) > engagement.mostRecentYear) {
      setTargetErrorBaseYear(addTargetSpecificationBaseYearLessThanMRY);
      isValid = false;
    }

    if (
      baseSpecYear &&
      parseFloat(baseSpecYear) <= engagement.mostRecentYear - 10
    ) {
      setTargetErrorBaseYear(addTargetSpecificationBaseYearGreaterThanFEY);
      isValid = false;
    }

    if (!targetSpecYear) {
      setTargetErrorTargetYear(addTargetSpecificationTargetYearRequired);
      isValid = false;
    }

    if (
      targetSpecYear &&
      parseFloat(targetSpecYear) < engagement.mostRecentYear
    ) {
      setTargetErrorTargetYear(addTargetSpecificationTargetYearGreaterThanMRY);
      isValid = false;
    }

    if (
      targetSpecYear &&
      parseFloat(targetSpecYear) > engagement?.foreCastEndYear
    ) {
      setTargetErrorTargetYear(addTargetSpecificationTargetYearLessThanFEY);
      isValid = false;
    }

    if (!selectedUIAllFilters || !Object.entries(selectedUIAllFilters)?.length > 0)  {
      setForecastErrorDataSelectionModal(addForecastSpecificationDataSelectionRequired);
      isValid = false;
    } else {
      if (orgSpecModalData?.entity_level1?.length === 0) {
        setForecastErrorDataSelectionModal(addForecastSpecificationDataSelectionRequired);
        isValid = false;
      }
    }

    return isValid;
  }

  async function findSmallest(arrays) {
    let smallest = arrays[0];
    let minlength = arrays[0]?.length;
    arrays.forEach((array) => {
      if (array?.length < minlength) {
        smallest = array;
        minlength = array?.length;
      }
    });
    let finalArray = Array.from(new Set(smallest?.map(JSON.stringify))).map(
      JSON.parse
    );
    if (emissionModalData?.selectAll === "subCategory1") {
      finalArray.forEach((record) => {
        record.category_level1 = "All";
        record.category_level2 = "All";
        record.category_level3 = "All";
      });
    } else if (emissionModalData?.selectAll === "subCategory2") {
      finalArray?.forEach((record) => {
        record.category_level2 = "All";
        record.category_level3 = "All";
      });
    } else if (emissionModalData?.selectAll === "subCategory3") {
      finalArray?.forEach((record) => {
        record.category_level3 = "All";
      });
    }
    if (geoSpecModalData?.selectAll === "regionLevel1") {
      finalArray?.forEach((record) => {
        record.region_level1 = "All";
        record.region_level2 = "All";
        record.region_level3 = "All";
      });
    } else if (geoSpecModalData?.selectAll === "regionLevel2") {
      finalArray?.forEach((record) => {
        record.region_level2 = "All";
        record.region_level3 = "All";
      });
    } else if (geoSpecModalData?.selectAll === "regionLevel3") {
      finalArray?.forEach((record) => {
        record.region_level3 = "All";
      });
    }
    if (customModalData?.selectAll === "customLevel1") {
      finalArray?.forEach((record) => {
        record.custom_specification1 = "All";
        record.custom_specification2 = "All";
        record.custom_specification3 = "All";
      });
    } else if (customModalData?.selectAll === "customLevel2") {
      finalArray?.forEach((record) => {
        record.custom_specification2 = "All";
        record.custom_specification3 = "All";
      });
    } else if (customModalData?.selectAll === "customLevel3") {
      finalArray?.forEach((record) => {
        record.custom_specification3 = "All";
      });
    }
    if (orgSpecModalData?.selectAll === "orgLevel1") {
      finalArray?.forEach((record) => {
        record.entity_level1 = "All";
        record.entity_level2 = "All";
        record.entity_level3 = "All";
        record.entity_level4 = "All";
      });
    } else if (orgSpecModalData?.selectAll === "orgLevel2") {
      finalArray?.forEach((record) => {
        record.entity_level2 = "All";
        record.entity_level3 = "All";
        record.entity_level4 = "All";
      });
    } else if (orgSpecModalData?.selectAll === "orgLevel3") {
      finalArray?.forEach((record) => {
        record.region_level3 = "All";
        record.entity_level4 = "All";
      });
    } else if (orgSpecModalData?.selectAll === "orgLevel4") {
      finalArray?.forEach((record) => {
        record.entity_level4 = "All";
      });
    }
    finalArray = Array.from(new Set(finalArray?.map(JSON.stringify))).map(
      JSON.parse
    );
    return finalArray;
  }

  async function applyChanges() {
    dispatch(setWafErrorFlag(false));
    let isSubmit = false;
    if (!validateForm()) return;
    setIsDataSaveInProgress(true);
    let allpayload = [];
    let finalUniquerecords = [];
    if (customModalData?.allPayload?.length > 0) {
      let arrays = [
        geoSpecModalData.allPayload,
        orgSpecModalData.allPayload,
        customModalData.allPayload,
      ];
      let finalArray = await findSmallest(arrays);
      finalUniquerecords = finalArray;
    } else {
      let arrays = [geoSpecModalData.allPayload, orgSpecModalData.allPayload];

      let finalArray = await findSmallest(arrays);
      finalArray.forEach((record) => {
        record.custom_specification1 = "All";
        record.custom_specification2 = "All";
        record.custom_specification3 = "All";
      });
      finalUniquerecords = finalArray;
    }

    try {
      if (targetData?.id) {
        finalUniquerecords.forEach((record) => {
          let request = {
            engagementID: engagement.id,
            clientname: engagement.clientName,
            name: targetSpecName,
            description: targetDescription,
            region_level1: record.region_level1,
            region_level2: record.region_level2,
            region_level3: record.region_level3,
            entity_level1: record.entity_level1,
            entity_level2: record.entity_level2,
            entity_level3: record.entity_level3,
            entity_asset: record.entity_level4,
            scope: record.scope,
            category_level1: record.category_level1,
            category_level2: record.category_level2,
            category_level3: record.category_level3,
            custom_specification1: record.custom_specification1,
            custom_specification2: record.custom_specification2,
            custom_specification3: record.custom_specification3,
            target_type: targetSpecType,
            temporal_type: targetSpecTemporalType,
            target_percentage: percentageValue,
            target_year: parseFloat(targetSpecYear),
            baseYear: parseFloat(baseSpecYear),
            batchId: targetData?.batchId ?? 0,
            batchGroupID: targetData?.batchGroupID ?? 0,
            statusFlag: targetData?.statusFlag ?? "",
            aD_Key: targetData?.aD_Key ?? "",
            activeFlag: targetData?.activeFlag ?? 1,
            id: targetData?.id ?? 0,
            modifiedby: targetData?.modifiedby ?? user.username,
            modifieddate: targetData?.modifieddate ?? new Date(),
            status: "",
            updatestatus: "",
            record_status: "",
            target_status: "",
            isValidated: "Y",
          };
          allpayload.push(request);
        });

        const response = await allUpdateTarget({ allpayload });
        if(response && response?.data) {
          isSubmit = true;
        }
      } else {
        finalUniquerecords.forEach((record) => {
          let request = {
            engagementID: engagement.id,
            clientname: engagement.clientName,
            name: targetSpecName,
            description: targetDescription,
            region_level1: record.region_level1,
            region_level2: record.region_level2,
            region_level3: record.region_level3,
            entity_level1: record.entity_level1,
            entity_level2: record.entity_level2,
            entity_level3: record.entity_level3,
            entity_asset: record.entity_level4,
            scope: record.scope,
            category_level1: record.category_level1,
            category_level2: record.category_level2,
            category_level3: record.category_level3,
            custom_specification1: record.custom_specification1,
            custom_specification2: record.custom_specification2,
            custom_specification3: record.custom_specification3,
            target_type: targetSpecType,
            temporal_type: targetSpecTemporalType,
            target_percentage: percentageValue,
            target_year: parseFloat(targetSpecYear),
            baseYear: parseFloat(baseSpecYear),
            createddate: targetData?.createddate ?? new Date(),
            createdby: targetData?.createdby ?? user.username,
            batchId: targetData?.batchId ?? 0,
            batchGroupID: targetData?.batchGroupID ?? 0,
            statusFlag: targetData?.statusFlag ?? "",
            aD_Key: targetData?.aD_Key ?? "",
            activeFlag: targetData?.activeFlag ?? 1,
            id: targetData?.batchGroupID ?? 0,
            status: "",
            updatestatus: "",
            record_status: "",
            target_status: "",
            isValidated: "Y",
          };
          allpayload.push(request);
        });
        const response = await allSaveTargetSpecification({ allpayload });
        if(response && response?.data) {
          isSubmit = true;
        }
      }
    } catch (e) {
      isSubmit = false;
      console.error(e);
    }

    let payload = {
      engagementId: engagement.id,
      engagementCode: engagement.engagementCode,
      name: targetSpecName,
      clientname: engagement.clientName,
      description: targetDescription,
      target_type: targetSpecType,
      temporal_type: targetSpecTemporalType,
      target_percentage: percentageValue,
      baseYear: parseFloat(baseSpecYear),
      target_year: parseFloat(targetSpecYear),
      createddate: targetData?.createddate ?? new Date(),
      createdby: targetData?.createdby ?? user.username,
      id: targetData?.batchGroupID ?? 0,
      dropDownMetaData: [],
    };

    // Emission Data
    const selectedScope = (emissionModalData?.scope || [])?.map((x) => {
      return { columnType: "Scope", columnValue: x };
    });
    const selectedCatLevel1 = emissionModalData?.category_level1?.map((x) => {
      return { columnType: "Category_level1", columnValue: x };
    });
    const selectedCatLevel2 = emissionModalData?.category_level2?.map((x) => {
      return { columnType: "Category_level2", columnValue: x };
    });
    const selectedCatLevel3 = emissionModalData?.category_level3?.map((x) => {
      return { columnType: "Category_level3", columnValue: x };
    });

    //Geo Data
    const selectedRegionLevel1 = geoSpecModalData?.region_level1?.map((x) => {
      return { columnType: "Region_level1", columnValue: x };
    });
    const selectedRegionLevel2 = geoSpecModalData?.region_level2?.map((x) => {
      return { columnType: "Region_level2", columnValue: x };
    });
    const selectedRegionLevel3 = geoSpecModalData?.region_level3?.map((x) => {
      return { columnType: "Region_level3", columnValue: x };
    });

    //Org Data
    const selectedEntityLevel1 = orgSpecModalData?.entity_level1?.map((x) => {
      return { columnType: "Entity_level1", columnValue: x };
    });
    const selectedEntityLevel2 = orgSpecModalData?.entity_level2?.map((x) => {
      return { columnType: "Entity_level2", columnValue: x };
    });
    const selectedEntityLevel3 = orgSpecModalData?.entity_level3?.map((x) => {
      return { columnType: "Entity_level3", columnValue: x };
    });
    const selectedEntityLevel4 = orgSpecModalData?.entity_level4?.map((x) => {
      return { columnType: "Entity_level4", columnValue: x };
    });

    //Custom Data
    let selectedCustom1,
      selectedCustom2,
      selectedCustom3 = [];
    if (
      customModalData.custom_specification1 &&
      !customModalData.custom_specification1.includes("N/A")
    ) {
      selectedCustom1 = customModalData.custom_specification1.map((x) => {
        return { columnType: "Custom_specification1", columnValue: x };
      });
      selectedCustom2 = customModalData.custom_specification2.map((x) => {
        return { columnType: "Custom_specification2", columnValue: x };
      });
      selectedCustom3 = customModalData.custom_specification3.map((x) => {
        return { columnType: "Custom_specification3", columnValue: x };
      });
    } else {
      selectedCustom1 = [
        { columnType: "Custom_specification1", columnValue: "All" },
      ];
      selectedCustom2 = [
        { columnType: "Custom_specification2", columnValue: "All" },
      ];
      selectedCustom3 = [
        { columnType: "Custom_specification3", columnValue: "All" },
      ];
    }

    payload.dropDownMetaData = [
      ...selectedScope,
      ...selectedCatLevel1,
      ...selectedCatLevel2,
      ...selectedCatLevel3,
      ...selectedRegionLevel1,
      ...selectedRegionLevel2,
      ...selectedRegionLevel3,
      ...selectedEntityLevel1,
      ...selectedEntityLevel2,
      ...selectedEntityLevel3,
      ...selectedEntityLevel4,
      ...selectedCustom1,
      ...selectedCustom2,
      ...selectedCustom3,
    ];

    let isEditTargetDuplicate = false;
    let isNewTargetDuplicate = false;

    if (alternativeOutput === true && targetSpecType === "Intensity") {
      const intensityTargetData = intenstiyTargetDataSet;
      let dataArr = [];
      var result = Object.keys(intensityTargetData).map((key) => [
        key,
        intensityTargetData[key],
      ]);
      if (result.length > 2) {
        result.map((item, i) => {
          if (i < result.length - 2) {
            dataArr.push({
              activityYear: Number(item[0]),
              manualIntensity_Value: Number(item[1]),
            });
          }
        });
      } else {
        for (let i = 0; i <= +targetSpecYear - +baseSpecYear; i++) {
          dataArr.push({
            activityYear: Number(baseSpecYear) + i,
            manualIntensity_Value: 0,
          });
        }
      }
      // payload["targetTypeID"] = 1
      payload["manualIntensity_flag"] = "Y";
      payload["data_type"] = intenstiyTargetDataSet?.dataType;
      payload["manualIntensity_Unit"] = intenstiyTargetDataSet?.outputUnit;
      payload["intensityTargetData"] = dataArr;
      try {
        if (targetData?.id) {
          const editTargetResult = await updateTargetSpecification({ payload });
          if (editTargetResult && editTargetResult?.data) {
            isSubmit = true;
          }
          // isEditTargetDuplicate = editTargetResult.data[0].isDuplicate === "Y" ? true : false;
        } else {
          const newTargetResult = await saveTargetSpecification({ payload });
          if (newTargetResult && newTargetResult?.data) {
            isSubmit = true;
          }
          // isNewTargetDuplicate = newTargetResult.data[0].isDuplicate === "Y" ? true : false
        }
      } catch (e) {
        isSubmit = false;
        console.error(e);
      }
    } else {
      payload["manualIntensity_flag"] = "N";
      payload["data_type"] = "";
      payload["manualIntensity_Unit"] = "";
      payload["intensityTargetData"] = [];
      try {
        if (targetData?.id) {
          const editTargetResult = await updateTargetSpecification({ payload });
          if (editTargetResult && editTargetResult?.data) {
            isSubmit = true;
          }
          isEditTargetDuplicate =
            editTargetResult?.data[0]?.isDuplicate === "Y" ? true : false;
        } else {
          const newTargetResult = await saveTargetSpecification({ payload });
          if (newTargetResult && newTargetResult?.data) {
            isSubmit = true;
          }
          isNewTargetDuplicate =
            newTargetResult?.data[0]?.isDuplicate === "Y" ? true : false;
        }
      } catch (e) {
        isSubmit = false;
        console.error(e);
      }
    }

    if (isEditTargetDuplicate || isNewTargetDuplicate) {
      setIsDataSaveInProgress(false);
      setIsDisableSave(false);
      setShowTargetValidationMsg(true);
      return;
    } else {
      setIsDataSaveInProgress(false);
      if (isSubmit) {
        navigate(`/${routes.createNewEngagement}/${routes.addTarget}`, {
          state: {
            engagementId: engagement.id,
          },
          gestureEnabled: false,
        });
      }
    }
  }

  const onTargetValidationModalClose = () => {
    setShowTargetValidationMsg(false);
  };

  async function GetAllHierarchyData() {
    const request = {
      engagement: engagement.engagementCode,
      clientName: engagement.clientName,
    };
    const data = await getHierarchyLevelData({ request });
    dispatch(setHierarchialData({ hierarchialData: data }));
    setHierarchyData(data);
  }

  useEffect(() => {
    if (engagement?.id) {
      GetAllHierarchyData();
    }
  }, [engagement?.id]);


  useEffect(() => {
    if (engagement?.id && state?.batchGroupId) {
      getTargetByGroupId(engagement?.id, state?.batchGroupId);
      setIsDisableSave(true);
    }
  }, [engagement?.id, state?.batchGroupId, hierarchialData]);

  async function checkTargetName(value) {
    if (!value || lastCheckedTargetName.current === value) return;
    if(targetNameRegExp.test(value) && value) {
      lastCheckedTargetName.current = value;
      const request = {
        name: encodeURIComponent(value),
        type: "Target",
        engagementId: engagement.id,
      };
      const data = await checkName({ request });
      if (data.code === 1) {
        setTargetErrorName(data.status);
      } else {
        setTargetErrorName("");
      }
    }
  }

  function checkIsDisabled (){
    if(!isDisableSave){
      if(isDataSaveInProgress || targetSpecName == "" || targetErrorName !== "" || targetErrorDescription || percentageValue == undefined || baseSpecYear == undefined || targetErrorTargetYear !== "" || targetErrorBaseYear !== "" || targetErrorPercent !== "" || forecastErrorDataSelectionModal != "" || !selectedUIAllFilters || !Object.entries(selectedUIAllFilters)?.length > 0){
        return true;
      } else {
        return false;
      }
    } else{
      if(isDataSaveInProgress || targetSpecName == "" || targetErrorName !== "" || targetErrorDescription || percentageValue == undefined || baseSpecYear == undefined  || targetErrorTargetYear !== "" || targetErrorBaseYear !== "" || targetErrorPercent !== "" || forecastErrorDataSelectionModal != "" || !selectedUIAllFilters || !Object.entries(selectedUIAllFilters)?.length > 0){
        return true;
      } else {
        return false;
      }
    }
  }
  
  const handleFilterModalConfirm = (data) => {
    setEmissionModalData(data?.emissionData);
    setGeoSpecModalData(data?.regionalData);
    setOrgSpecModalData(data?.organisationalData);
    setCustomModalData(data?.customSpecificationData);
  }

  async function getTargetByGroupId(engId, groupId) {
    const request = {
      engagementId: engId,
      batchGroupId: groupId,
    };
    setDropDownError(true);
    setIsDisableSave(true);
    const data = await getForecastTargetByGroupId({
      request,
    });

    setIsEditTarget(true);
    setTargetData(data.data[data.data.length - 1]);
    setTargetSpecName(data.data[data.data.length - 1].name);
    setTargetDescription(data.data[data.data.length - 1].description);
    setTargetSpecType(data.data[data.data.length - 1].target_type);
    setTargetSpecTypeDisable(true);
    setTargetSpecTemporalType(data.data[data.data.length - 1].temporal_type);
    setPercentage(data.data[data.data.length - 1].target_percentage);
    setBaseSpecYear(data.data[data.data.length - 1].baseYear);
    setTargetSpecYear(data.data[data.data.length - 1].target_year);
    setTargetIntensityDataType(data.data[data.data.length - 1].data_type);
    setTargetIntensityOutputUnit(data.data[data.data.length - 1].output_Unit);
    setTargetIntensityYearData(
      data.data[data.data.length - 1].intensityTargetData
    );

    let scopeArray = [...new Set(data.data.map((element) => element.scope))];
    // setScopeArray(scopeArray);

    let category_level1 = [
      ...new Set(data.data.map((element) => element.category_level1)),
    ];
    let category_level2 = [
      ...new Set(data.data.map((element) => element.category_level2)),
    ];
    let category_level3 = [
      ...new Set(data.data.map((element) => element.category_level3)),
    ];
    
    let allFilters = {};

    if (state.isValidated === "N") {
      allFilters['scope'] = [];
      allFilters['category_level1'] = [];
      allFilters['category_level2'] = [];
      allFilters['category_level3'] = [];
    } else {
      allFilters['scope'] = scopeArray;
      allFilters['category_level1'] = category_level1;
      allFilters['category_level2'] = category_level2;
      allFilters['category_level3'] = category_level3;
    }

    let entity_level1 = [
      ...new Set(data.data.map((element) => element.entity_level1)),
    ];
    let entity_level2 = [
      ...new Set(data.data.map((element) => element.entity_level2)),
    ];
    let entity_level3 = [
      ...new Set(data.data.map((element) => element.entity_level3)),
    ];
    let entity_level4 = [
      ...new Set(data.data.map((element) => element.entity_asset)),
    ];

    if (state.isValidated === "N") {
      allFilters['entity_level1'] = [];
      allFilters['entity_level2'] = [];
      allFilters['entity_level3'] = [];
      allFilters['entity_level4'] = [];
    } else {
      allFilters['entity_level1'] = entity_level1;
      allFilters['entity_level2'] = entity_level2;
      allFilters['entity_level3'] = entity_level3;
      allFilters['entity_level4'] = entity_level4;
    }

    let region_level1 = [
      ...new Set(data.data.map((element) => element.region_level1)),
    ];
    let region_level2 = [
      ...new Set(data.data.map((element) => element.region_level2)),
    ];
    let region_level3 = [
      ...new Set(data.data.map((element) => element.region_level3)),
    ];

    if (state.isValidated === "N") {
      allFilters['region_level1'] = [];
      allFilters['region_level2'] = [];
      allFilters['region_level3'] = [];
    } else {
      allFilters['region_level1'] = region_level1;
      allFilters['region_level2'] = region_level2;
      allFilters['region_level3'] = region_level3;
    }

    let custom_specification1 = [
      ...new Set(data.data.map((element) => element.custom_specification1)),
    ];
    let custom_specification2 = [
      ...new Set(data.data.map((element) => element.custom_specification2)),
    ];
    let custom_specification3 = [
      ...new Set(data.data.map((element) => element.custom_specification3)),
    ];

    if (state.isValidated === "N") {
      allFilters['custom_specification1'] = [];
      allFilters['custom_specification2'] = [];
      allFilters['custom_specification3'] = [];
    } else {
      allFilters['custom_specification1'] = custom_specification1;
      allFilters['custom_specification2'] = custom_specification2;
      allFilters['custom_specification3'] = custom_specification3;
    }

    // Emmission Records
    console.log('hierarchialData', hierarchialData);
    if(hierarchialData?.length > 0) {
      const uniqueRecords = await processEmissionData(allFilters, hierarchialData, allFilters);
      const allRecords = await handleAllpayload('Emission', allFilters, allFilters, hierarchialData);
      const newRecords = {
          records: uniqueRecords,
          scope: allFilters?.scope,
          category_level1: allFilters?.category_level1,
          category_level2: allFilters?.category_level2,
          category_level3: allFilters?.category_level3,
          allPayload: allRecords?.length > 0 ? allRecords : uniqueRecords,
          selectAll: '',
          functionality: "Edit",
      };

      // Organisational Records
      const uniqueOrgRecords = await processOrgData(allFilters, hierarchialData, allFilters);
      const allOrgRecords = await handleAllpayload('Organisational', allFilters, allFilters, hierarchialData);
      const newOrgRecords = {
          records: uniqueOrgRecords,
          entity_level1: allFilters?.entity_level1,
          entity_level2: allFilters?.entity_level2,
          entity_level3: allFilters?.entity_level3,
          entity_level4: allFilters?.entity_level4,
          allPayload: allOrgRecords?.length > 0 ? allOrgRecords : uniqueOrgRecords,
          selectAll: '',
          functionality: "Edit",
      };

      // Regional Records
      const uniqueRegionRecords = await processRegionData(allFilters, hierarchialData, allFilters);
      const allRegionRecords = await handleAllpayload('Regional', allFilters, allFilters, hierarchialData);
      const newRegionRecords = {
          records: uniqueRegionRecords,
          region_level1: allFilters?.region_level1,
          region_level2: allFilters?.region_level2,
          region_level3: allFilters?.region_level3,
          allPayload: allRegionRecords?.length > 0 ? allRegionRecords : uniqueRegionRecords,
          selectAll: '',
          functionality: "Edit",
      };

      // Custom Specification Records
      const uniqueCustomRecords = await processCustomData(allFilters, hierarchialData, allFilters);
      const allCustomRecords = await handleAllpayload('Custom', allFilters, allFilters, hierarchialData);
      const newCustomRecords = {
          records: uniqueCustomRecords,
          custom_specification1: allFilters?.custom_specification1,
          custom_specification2: allFilters?.custom_specification2,
          custom_specification3: allFilters?.custom_specification3,
          allPayload: allCustomRecords?.length > 0 ? allCustomRecords : uniqueCustomRecords,
          selectAll: '',
          functionality: "Edit",
      };

      console.log('newRecords', {
          emissionData: newRecords,
          organisationalData: newOrgRecords,
          regionalData: newRegionRecords,
          customSpecificationData: newCustomRecords
      });
      setEmissionModalData(newRecords);
      setGeoSpecModalData(newRegionRecords);
      setOrgSpecModalData(newOrgRecords);
      setCustomModalData(newCustomRecords);
    }

    // New code: Bhushan
    dispatch(setselectedUIAllFilters({selectedUIAllFilters: allFilters}));

    setTimeout(() => {
      setDropDownError(false);
    }, 2000);
  }

  const handleTargetNameChange = (event) => {
      dispatch(setWafErrorFlag(false));
      let error = "";
      if (event.target.value?.length >= maxLength100) {
        error = addTargetNameRequiredMaxLength;
        setTargetErrorName(error);
        return;
      } else {
        error = "";
        setTargetErrorName(error);
      } 
      setTargetSpecName(event.target.value);
      if (
          targetNameRegExp.test(event.target.value) &&
          event.target.value !== "-"
        ) {
          
          if (event.target.value === "") {
            error = addTargetSpecificationForecastNameRequired;
            lastCheckedTargetName.current = "";
          }
          setTargetErrorName(error);
        } else {
          error = commonError;
          setTargetErrorName(error);
        }
    };
  
    const handelTargetDescriptionChange = (event) => {
      dispatch(setWafErrorFlag(false));
      let error = "";
      // Always update the value to allow typing/pasting
      setTargetDescription(event.target.value);
      // Check validations
      if (event.target.value?.length >= maxLength2000) {
        // Length exceeds 2000 characters
        error = addTargetDescriptionMaxLength;
      } else if (!targetDescRegExp.test(event.target.value) || event.target.value === "-") {
        // Invalid characters
        error = commonError;
      }
      
      setTargetErrorDescription(error);
    }

  useEffect(
    () => () => {
      setTargetErrorBaseYear("");
      setTargetErrorName("");
      setTargetErrorDescription("");
      setTargetErrorPercent("");
      setTargetErrorTargetYear("");
      setTargetErrorTemporal("");
      setTargetErrorType("");
      setTargetSpecName("");
      setTargetDescription("");
      setTargetSpecType("");
      setTargetSpecTemporalType("");
      setPercentage("");
      setBaseSpecYear("");
      setTargetSpecYear("");
      setEmissionModalData([]);
      setGeoSpecModalData([]);
      setOrgSpecModalData([]);
      setCustomModalData([]);
      setTargetData({});
      setIsDataSaveInProgress(false);
      setTargetSpecTypeDisable(false);
    },
    []
  );

  return (
    <div className="add-target-specification">
      <div className="add-target-specification-header">
        <div className="add-target-specification-header-title">
          {steps[currentStep]?.stepHeading}
        </div>
        <div className="add-target-specification-header-stepper">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            stepIndex={stepIndex}
          />
        </div>
      </div>
      <div className="add-target-specification-content">
        <div className="add-target-specification-content-header">
          <div className="add-target-specification-content-header-main">
            <span>{addTargetSpecificationName}</span>
          </div>
        </div>
        <div className="add-target-specification-content-body">
          <div className="add-target-specification-content-body-row">
            <span className="add-target-specification-content-body-name-title decarb-input-error-label">
              {addTargetSpecificationTargetName}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={targetNameTooltip}
              ></Tooltip>
            </span>
            <Input
              type={"text"}
              value={targetSpecName}
              onChange={handleTargetNameChange}
              onBlur={(event) => {
                checkTargetName(event.target.value);
              }}
              errorMessage={targetErrorName}
              isError={targetErrorName !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress || targetData?.id}
            ></Input>
          </div>
          <div className="add-target-specification-content-body-row">
            <span className="add-target-specification-content-body-desc-title">
              {addTargetSpecificationTargetDesc}
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={targetDescriptiontooltip}
              ></Tooltip>
            </span>
            <div
              style={{ flex: 1 }}
              className="add-forecast-specification-body-error-button"
            >
              <TextArea
                value={targetDescription}
                onChange={handelTargetDescriptionChange}
                errorMessage={targetErrorDescription}
                isError={targetErrorDescription !== ""}
                disabled={isDataSaveInProgress}
              />
              <div className="decarb-input-hide-error">No Error</div>
            </div>
          </div>
          <div className="add-target-specification-content-body-row">
            <span className="add-target-specification-content-body-name-title decarb-input-error-label">
              {addTargetSpecificationTargetType}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={targetTypetooltip}
              ></Tooltip>
            </span>
            <div style={{ flex: 1 }}>
              <Select
                value={targetSpecType}
                options={addTargetSpecificationTargetTypeOptions}
                onChange={(event) => {
                  setTargetSpecType(event);
                  setTargetErrorType("");
                }}
                errorMessage={targetErrorType}
                isError={targetErrorType !== ""}
                disableErrorPlaceholder={false}
                disabled={isDataSaveInProgress || targetSpecTypeDisable}
              />
            </div>
            <span className="add-target-specification-content-body-name-title decarb-input-error-label">
              {addTargetSpecificationTargetTemporalType}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={temporalTypeTooltip}
              ></Tooltip>
            </span>
            <div style={{ flex: 1 }}>
              <Select
                value={targetSpecTemporalType}
                options={addTargetSpecificationTemporalTypeOptions}
                onChange={(event) => {
                  setTargetSpecTemporalType(event);
                  setTargetErrorTemporal("");
                  setTargetErrorPercent("");
                }}
                errorMessage={targetErrorTemporal}
                isError={targetErrorTemporal !== ""}
                disableErrorPlaceholder={false}
                disabled={isDataSaveInProgress}
              />
            </div>
          </div>
          <div className="add-target-specification-content-body-row">
            <span className="add-target-specification-content-body-name-title decarb-input-error-label">
              {targetSpecTemporalType === "Annual"
                ? addTargetSpecificationPercentValueAnnual
                : addTargetSpecificationPercentValueTargetYear}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={targetPercentageTooltip}
              ></Tooltip>
            </span>
            <Input
              type="decimal"
              maxLength={5}
              value={percentageValue}
              onChange={(event) => {
                setPercentage(event.target.value);
                setTargetErrorPercent("");

                if (!event.target.value) {
                  setTargetErrorPercent(
                    targetSpecTemporalType === "Annual"
                      ? addTargetSpecificationPercentValueAnnualRequired
                      : addTargetSpecificationPercentValueTargetYearRequired
                  );
                }

                if (
                  event.target.value &&
                  (!decimalNumberRegExp.test(event.target.value) ||
                    event.target.value > 100 ||
                    event.target.value < -99.99)
                ) {
                  setTargetErrorPercent(targetPercentageError);
                }
              }}
              errorMessage={targetErrorPercent}
              isError={targetErrorPercent !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress}
            ></Input>
            <span className="add-target-specification-content-body-name-title decarb-input-hide-error">
              <span className="required-star">*</span>
            </span>
            <Input
              className={"decarb-input-hide-error"}
              hideClearButton
              disabled={isDataSaveInProgress}
              type={"text"}
            ></Input>
          </div>
          <div className="add-target-specification-content-body-row">
            <span className="add-target-specification-content-body-name-title decarb-input-error-label">
              {addTargetSpecificationBaseYear}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={targetBaseYearTooltip}
              ></Tooltip>
            </span>
            <Input
              type="number"
              maxLength={4}
              value={baseSpecYear}
              onChange={(event) => {
                let year = event.target.value;
                setBaseSpecYear(year);
                setTargetErrorBaseYear("");
                setTargetIntensityYearData({});

                if (!year) {
                  setTargetErrorBaseYear(
                    addTargetSpecificationBaseYearRequired
                  );
                }

                if (year && parseFloat(year) > engagement.mostRecentYear) {
                  setTargetErrorBaseYear(
                    addTargetSpecificationBaseYearLessThanMRY
                  );
                }

                if (
                  year &&
                  parseFloat(year) <= engagement.mostRecentYear - 10
                ) {
                  setTargetErrorBaseYear(
                    addTargetSpecificationBaseYearGreaterThanFEY
                  );
                }
              }}
              errorMessage={targetErrorBaseYear}
              isError={targetErrorBaseYear !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress}
            ></Input>
            <span className="add-target-specification-content-body-name-title decarb-input-error-label">
              {addTargetSpecificationTargetYear}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={targetYearTooltip}
              ></Tooltip>
            </span>
            <Input
              type="number"
              maxLength={4}
              value={targetSpecYear}
              onChange={(event) => {
                let year = event.target.value;
                setTargetSpecYear(year);
                setTargetErrorTargetYear("");
                setTargetIntensityYearData({});
                if (!year) {
                  setTargetErrorTargetYear(
                    addTargetSpecificationTargetYearRequired
                  );
                }

                if (year && parseFloat(year) < engagement.mostRecentYear) {
                  setTargetErrorTargetYear(
                    addTargetSpecificationTargetYearGreaterThanMRY
                  );
                }

                if (year && parseFloat(year) > engagement?.foreCastEndYear) {
                  setTargetErrorTargetYear(
                    addTargetSpecificationTargetYearLessThanFEY
                  );
                }
              }}
              errorMessage={targetErrorTargetYear}
              isError={targetErrorTargetYear !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress}
            ></Input>
          </div>
            <div class="motif-row">
              <div class="motif-col-xs-2 data-selection-label-target">
                <LoadingIndicatorEmbed show={dropdownError}>
                  <Button
                    variant="primary-alt"
                    onClick={() => {
                      setOpenHierarchyModal(true);
                    }}
                    className="add-gmp-params-data-selection-btn-forecast"
                    disabled={isDataSaveInProgress || (state?.batchGroupId && dropdownError)}
                  >
                    <AreaSeacrhIcon />
                    {DataSelection} <span className="required-star">*</span>
                  </Button>
                </LoadingIndicatorEmbed>
                {forecastErrorDataSelectionModal ? (
                  <MotifErrorMessage className="decarb-input-error-message decarb-data-selection-forecast-error-message">
                    {addForecastSpecificationDataSelectionRequired}
                  </MotifErrorMessage>
                ) : (
                  <div className="decarb-input-hide-error">No Error</div>
                )}
              </div>
              {wafErrorFlag && <div className="waf-error-message">
                {wafErrorMessageState}
              </div>} 
            </div>
        </div>
      </div>
      <div className="add-target-specification-footer">
        <Button
          variant="secondary"
          onClick={handleCancelClick}
          disabled={isDataSaveInProgress}
        >
          {CancelBtn}
        </Button>
        <div className="new-engagement-footer-nav-buttons">
          <LoadingIndicatorEmbed show={isDataSaveInProgress}>
            <Button
              variant="primary"
              onClick={applyChanges}
              disabled={checkIsDisabled() || wafErrorFlag}
            >
              {SaveBtn}
            </Button>
          </LoadingIndicatorEmbed>
        </div>
      </div>

      <TargetIntensityValidationModal
        isModalVisible={showTargetValidationMsg}
        onClose={onTargetValidationModalClose}
      />

      <M2FilterModal
        isFilterOpen={openHierarchyModal}
        onClose={() => setOpenHierarchyModal(false)}
        onConfirm={handleFilterModalConfirm}
      />
    </div>
  );
}
